'use client'

import { type ReactNode, useEffect, useState } from 'react'

export function MountedAuthForm({ children }: { children: ReactNode }) {
  const [mounted, setMounted] = useState(false)
  useEffect(() => setMounted(true), [])

  // Clerk can load before a streamed boundary hydrates. Keep its first render
  // identical to the server instead of reading Clerk's changing loaded state.
  return mounted ? children : null
}
